"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralVendor = void 0;
/**
 * Enum represents the companies that can bring customers to your app.
 * Especially we need this enum to know which company referred a customer to
 * our app when the Platform points to the aggregator of the companies
 */
var ReferralVendor;
(function (ReferralVendor) {
    ReferralVendor["boltfood"] = "boltfood";
    ReferralVendor["glovo"] = "glovo";
    ReferralVendor["justeat"] = "justeat";
    ReferralVendor["smood"] = "smood";
    ReferralVendor["ubereats"] = "ubereats";
    ReferralVendor["wolt"] = "wolt";
})(ReferralVendor = exports.ReferralVendor || (exports.ReferralVendor = {}));
//# sourceMappingURL=referral-vendor.js.map